import React from 'react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { InfoOutlined, CloseOutlined } from '@material-ui/icons';
import { Dialog, Box, makeStyles, IconButton } from '@material-ui/core';
import { colorSet } from '@components/Provider';
import { useHistory } from 'react-router-dom';

interface Props {
  open: boolean;
  onClose: () => void;
}

const AlreadyGotPartnerAccountDialog = ({ open, onClose }: Props) => {
  const { root } = useStyles();
  const history = useHistory();

  return (
    <Dialog
      open={open}
      onClose={() => {
        history.push('/dashboard');
        onClose();
      }}
      classes={{ paper: root }}
    >
      <IconButton
        onClick={() => {
          history.push('/dashboard');
          onClose();
        }}
        className="closeButton"
      >
        <CloseOutlined />
      </IconButton>

      <Box display="flex" justifyContent="center" className="titleIcon">
        <InfoOutlined color="error" fontSize="large" />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        className="content"
      >
        <CustomizedTypography variant="h4" color="textPrimary" fontWeight="700">
          이미 파트너 등록 완료된 사업자등록번호 입니다.
        </CustomizedTypography>
        <CustomizedTypography variant="body2" className="gray700">
          등록된 계정을 확인하고 싶으실 경우 채널톡으로 문의주세요.
        </CustomizedTypography>
      </Box>

      <Box display="flex" flexDirection="column" className="button">
        <CustomizedButton
          variant="contained"
          color="primary"
          size="large"
          onClick={() => {
            history.push('/dashboard');
            onClose();
          }}
        >
          캐파 고객 서비스 이용하러 가기
        </CustomizedButton>
      </Box>
    </Dialog>
  );
};

export default AlreadyGotPartnerAccountDialog;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '44px 0px',
    borderRadius: 8,
    width: 'calc(100% - 32px)',
    maxWidth: 600,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .gray700': {
      color: colorSet.gray700
    },
    '& .closeButton': {
      position: 'absolute',
      top: 24,
      right: 24
    },
    '& .titleIcon': {
      '& svg': {
        width: 48,
        height: 48,
        marginBottom: 24
      }
    },
    '& .content': {
      marginBottom: 24,
      '& h4': {
        marginBottom: 8
      }
    },
    '& .button': {
      width: 320
    }
  }
}));
